import { render } from "./OrderPickup.vue?vue&type=template&id=d69aae8c"
import script from "./OrderPickup.vue?vue&type=script&lang=js"
export * from "./OrderPickup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DevelopmentWork\\app\\JGJWork\\vue\\t3custom_2pos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__